<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <div class="boxShadow heig-frame mt-16 border-top-right-radius">
                    <div class="padding-13 heig-frame-child scrollTableNoTab">
                        <gofix-default-table 
                            :settings="tableConfig" 
                            :table-items="tableItems" 
                            @load-items="getTableData" 
                            @row-click="clickToRowItem" 
                            @new-item="newItem" 
                            @delete-items="deleteItems"
                            @export="exportCSV" 
                            @nav-file-items="redirectToNav" 
                            ref="gofixTable">
                            <template slot="gofix_table:transaction_date" slot-scope="data">
                                {{data.item.transaction_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:document_date" slot-scope="data">
                                {{data.item.document_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:posting_datetime" slot-scope="data">
                                {{data.item.posting_datetime | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:line_item_gl_code" slot-scope="data">
                                {{data.item.check_header === 0 ? data.item.line_item_gl_code : ''}}
                            </template>
                            <template slot="gofix_table:line_item_gl_description" slot-scope="data">
                                {{data.item.check_header === 0 ? data.item.line_item_gl_description : ''}}
                            </template>
                            <template slot="gofix_table:dim_1" slot-scope="data">
                                {{data.item.check_header === 0 ? data.item.dim_1 : ''}}
                            </template>
                            <template slot="gofix_table:line_item_amount" slot-scope="data">
                                {{ data.item.line_item_amount | formatMoney }}
                            </template>
                            <template slot="gofix_table:line_item_tax_amount" slot-scope="data">
                                {{ data.item.line_item_tax_amount | formatMoney }}
                            </template>
                            <template slot="gofix_table:line_item_total" slot-scope="data">
                                {{ data.item.line_item_amount && data.item.line_item_tax_amount ? (parseFloat(data.item.line_item_amount) + parseFloat(data.item.line_item_tax_amount))
                                : data.item.line_item_amount && !data.item.line_item_tax_amount ? parseFloat(data.item.line_item_amount) : !data.item.line_item_amount && data.item.line_item_tax_amount ? parseFloat(data.item.line_item_tax_amount) : '' | formatMoney }}
                            </template>
                            <template slot="gofix_table:txn_account_type" slot-scope="data">
                                {{data.item.check_header === 1 ? data.item.txn_account_type : ''}}
                            </template>
                        </gofix-default-table>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { filters } from '@/_filterVar.js'

export default {
    name: 'general-ledger',
    components: {},
    data() {
        let filter = JSON.parse(JSON.stringify(filters['general_ledger']));
        return {
            tableConfig: {
                name: 'finance-general-ledger',
                controls: {
                    create: true,
                    delete: true,
                    tableImport: false,
                    nav_file: true
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: []
        }
    },
    computed: {},
    async created() {},
    methods: {
        /*---------- Table event ----------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            await this.$store.dispatch("GeneralLedgerController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    this.$bvToast.toast("Can not load General Ledger", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                    reject();
                });
        },
        newItem() {
            this.$router.push(`/v2/general-ledger/0`);
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            await this.$store.dispatch('GeneralLedgerController/deleteItem', { ids: ids })
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'gl_manual'));
                })
                .catch(err => {
                    reject();
                })
        },
        exportCSV() {
            this.$store.dispatch('GeneralLedgerController/exportCsv', this.$refs.gofixTable.tableRequest)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'GeneralLedgerList.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
        },
        clickToRowItem(item) {
            this.$router.push(`/v2/general-ledger/${item.id}`);
        },
        redirectToNav() {
            let route = this.$router.resolve({ path: `/v2/navision-file` })
            window.open(route.href, '_blank');
        }
    }
}
</script>